module.exports = __webpack_public_path__ + "static/media/yarina1.e2f1faf5.jpg";